module.exports = __webpack_public_path__ + "static/quick-union-comparison-e468a54109376d8deb270a1c91308ddd.png";